import { render, staticRenderFns } from "./SetPayPassword.vue?vue&type=template&id=d9fed0b2&scoped=true"
import script from "./SetPayPassword.vue?vue&type=script&lang=js"
export * from "./SetPayPassword.vue?vue&type=script&lang=js"
import style0 from "./SetPayPassword.vue?vue&type=style&index=0&id=d9fed0b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fed0b2",
  null
  
)

export default component.exports